/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LimitedProperties model module.
 * @module model/LimitedProperties
 * @version 1.0.0
 */
class LimitedProperties {
    /**
     * Constructs a new <code>LimitedProperties</code>.
     * @alias module:model/LimitedProperties
     */
    constructor() { 
        
        LimitedProperties.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LimitedProperties</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LimitedProperties} obj Optional instance to populate.
     * @return {module:model/LimitedProperties} The populated <code>LimitedProperties</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LimitedProperties();

            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('property_name')) {
                obj['property_name'] = ApiClient.convertToType(data['property_name'], 'String');
            }
            if (data.hasOwnProperty('property_area')) {
                obj['property_area'] = ApiClient.convertToType(data['property_area'], 'String');
            }
            if (data.hasOwnProperty('property_price')) {
                obj['property_price'] = ApiClient.convertToType(data['property_price'], 'Number');
            }
            if (data.hasOwnProperty('property_monthly_rent')) {
                obj['property_monthly_rent'] = ApiClient.convertToType(data['property_monthly_rent'], 'Number');
            }
            if (data.hasOwnProperty('property_nearest_station')) {
                obj['property_nearest_station'] = ApiClient.convertToType(data['property_nearest_station'], 'String');
            }
            if (data.hasOwnProperty('property_building_age')) {
                obj['property_building_age'] = ApiClient.convertToType(data['property_building_age'], 'Number');
            }
            if (data.hasOwnProperty('file_url')) {
                obj['file_url'] = ApiClient.convertToType(data['file_url'], 'String');
            }
            if (data.hasOwnProperty('object_storage_path')) {
                obj['object_storage_path'] = ApiClient.convertToType(data['object_storage_path'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LimitedProperties</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LimitedProperties</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['property_name'] && !(typeof data['property_name'] === 'string' || data['property_name'] instanceof String)) {
            throw new Error("Expected the field `property_name` to be a primitive type in the JSON string but got " + data['property_name']);
        }
        // ensure the json data is a string
        if (data['property_area'] && !(typeof data['property_area'] === 'string' || data['property_area'] instanceof String)) {
            throw new Error("Expected the field `property_area` to be a primitive type in the JSON string but got " + data['property_area']);
        }
        // ensure the json data is a string
        if (data['property_nearest_station'] && !(typeof data['property_nearest_station'] === 'string' || data['property_nearest_station'] instanceof String)) {
            throw new Error("Expected the field `property_nearest_station` to be a primitive type in the JSON string but got " + data['property_nearest_station']);
        }
        // ensure the json data is a string
        if (data['file_url'] && !(typeof data['file_url'] === 'string' || data['file_url'] instanceof String)) {
            throw new Error("Expected the field `file_url` to be a primitive type in the JSON string but got " + data['file_url']);
        }
        // ensure the json data is a string
        if (data['object_storage_path'] && !(typeof data['object_storage_path'] === 'string' || data['object_storage_path'] instanceof String)) {
            throw new Error("Expected the field `object_storage_path` to be a primitive type in the JSON string but got " + data['object_storage_path']);
        }

        return true;
    }


}



/**
 * @member {Number} agent_id
 */
LimitedProperties.prototype['agent_id'] = undefined;

/**
 * @member {String} property_name
 */
LimitedProperties.prototype['property_name'] = undefined;

/**
 * @member {String} property_area
 */
LimitedProperties.prototype['property_area'] = undefined;

/**
 * @member {Number} property_price
 */
LimitedProperties.prototype['property_price'] = undefined;

/**
 * @member {Number} property_monthly_rent
 */
LimitedProperties.prototype['property_monthly_rent'] = undefined;

/**
 * @member {String} property_nearest_station
 */
LimitedProperties.prototype['property_nearest_station'] = undefined;

/**
 * @member {Number} property_building_age
 */
LimitedProperties.prototype['property_building_age'] = undefined;

/**
 * @member {String} file_url
 */
LimitedProperties.prototype['file_url'] = undefined;

/**
 * @member {String} object_storage_path
 */
LimitedProperties.prototype['object_storage_path'] = undefined;






export default LimitedProperties;

